import React from "react";

function trialCenterSVGNew({
  isActive, 
  activeColor = "#232323",
  inactiveColor = "#868686" }: 
  { isActive: boolean; activeColor?: string; inactiveColor?: string; }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 22 22"
      fill={isActive ? activeColor : inactiveColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.369 4.65609C16.812 4.09909 16.0461 3.89022 15.2802 4.16872L5.46314 7.44108C4.41877 7.7892 3.79215 8.9032 4.14027 10.0172C4.34914 10.5742 4.76689 11.0616 5.32389 11.2704L8.94437 12.6629C9.08362 12.7326 9.22287 12.8718 9.29249 13.0111L10.685 16.6315C10.9635 17.3974 11.7294 17.9544 12.5649 17.9544C12.5649 17.9544 12.5649 17.9544 12.6345 17.9544C13.47 17.9544 14.2358 17.3974 14.5143 16.5619L17.7867 6.67521C18.1348 5.97896 17.926 5.14347 17.369 4.65609Z"
        fill={isActive ? activeColor : inactiveColor}
      />
    </svg>
  );
}

export default trialCenterSVGNew;
